import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setVw_MembersList, setVw_MembersMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { getVw_Members } from "services/vw_membersService";
import Layout from "template";
import { Constant } from "template/Constant";
import { Vw_MembersTable } from "./table";
import { MembersForm } from "../members/form";

export const Vw_Members: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.vw_members);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState('');
  const getData = (page, pageSize, searchKey) => {
    getVw_Members(page, pageSize, searchKey).then((response) => {
      if (response && response.records) {
        dispatch(setVw_MembersList({ pageNo: page, pageSize: pageSize, list: response.records, totalCount: response.totalCount, searchKey: searchKey }));
      } else {
        dispatch(setVw_MembersMessage("No Record Found"));
      }
    })
  }

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(setVw_MembersMessage(''));
    setAction('edit');
  }
  return (
    <Layout>
      <div className="container-fluid">
        {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Vw_Members</h1>
        </div> */}
        <div className="d-flex flex-column min-vh-100">
          {rData.message ?
            <Alert variant={Constant.defaultAlertVarient} className="alert-dismissible fade">{rData.message}
              <Button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => dispatch(setVw_MembersMessage(''))}>
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert> : null}

          {action ? 
          <MembersForm hideShowForm={setAction} action={action} row={row} getData={getData} /> : 
          <Vw_MembersTable handleRowEdit={handleRowEdit} hideShowForm={setAction} getData={getData} />}
        </div>

      </div>
    </Layout >
  );
};

